(function () {
  var postcodeRanges = [
    { first: 200, last: 299, state: 'ACT' },
    { first: 800, last: 999, state: 'NT' },
    { first: 1000, last: 2599, state: 'NSW' },
    { first: 2600, last: 2618, state: 'ACT' },
    { first: 2619, last: 2899, state: 'NSW' },
    { first: 2900, last: 2920, state: 'ACT' },
    { first: 2921, last: 2999, state: 'NSW' },
    { first: 3000, last: 3999, state: 'VIC' },
    { first: 4000, last: 4999, state: 'QLD' },
    { first: 5000, last: 5999, state: 'SA' },
    { first: 6000, last: 6999, state: 'WA' },
    { first: 7000, last: 7999, state: 'TAS' }
  ];

  var mutation = 'mutation ShippingEstimateCartCreate($input: CartInput!) {' +
    ' cartCreate(input: $input) {' +
    '  cart {' +
    '   deliveryGroups(first: 5) {' +
    '    nodes {' +
    '     deliveryOptions {' +
    '      title' +
    '      estimatedCost { amount currencyCode }' +
    '     }' +
    '    }' +
    '   }' +
    '  }' +
    '  userErrors { message }' +
    ' }' +
    '}';

  function stateForPostcode(postcode) {
    if (!/^\d{4}$/.test(postcode)) return null;
    var numericPostcode = Number(postcode);
    var match = postcodeRanges.find(function (range) {
      return numericPostcode >= range.first && numericPostcode <= range.last;
    });
    return match ? match.state : null;
  }

  function setStatus(element, message) {
    element.textContent = message;
  }

  function renderRates(list, groups, fallbackLabel) {
    var options = [];
    (groups || []).forEach(function (group) {
      (group.deliveryOptions || []).forEach(function (option) {
        if (!option.estimatedCost) return;
        options.push(option);
      });
    });

    list.replaceChildren();
    if (!options.length) return false;

    options.forEach(function (option) {
      var item = document.createElement('li');
      var name = document.createElement('span');
      var price = document.createElement('strong');
      var currency = option.estimatedCost.currencyCode || 'AUD';
      var amount = Number(option.estimatedCost.amount);

      name.textContent = option.title || fallbackLabel;
      try {
        price.textContent = new Intl.NumberFormat('en-AU', {
          style: 'currency',
          currency: currency
        }).format(amount);
      } catch (error) {
        price.textContent = currency + ' ' + amount.toFixed(2);
      }

      item.className = 'thw-product-shipping-estimator__rate';
      item.append(name, price);
      list.appendChild(item);
    });

    list.hidden = false;
    return true;
  }

  function initialiseEstimator(root) {
    if (root.dataset.shippingEstimatorReady === 'true') return;
    root.dataset.shippingEstimatorReady = 'true';

    var form = root.querySelector('[data-shipping-estimator-form]');
    var postcodeInput = root.querySelector('[data-shipping-estimator-postcode]');
    var submitButton = root.querySelector('[data-shipping-estimator-submit]');
    var status = root.querySelector('[data-shipping-estimator-status]');
    var rates = root.querySelector('[data-shipping-estimator-rates]');
    var shopDomain = root.dataset.shopDomain;
    var variantId = root.dataset.variantId;
    var messages = root.dataset;

    if (!form || !postcodeInput || !submitButton || !status || !rates || !shopDomain || !variantId) return;

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      rates.hidden = true;
      rates.replaceChildren();

      var postcode = postcodeInput.value.trim();
      var state = stateForPostcode(postcode);
      if (!state) {
        setStatus(status, messages.invalidMessage);
        postcodeInput.focus();
        return;
      }

      submitButton.disabled = true;
      setStatus(status, messages.loadingMessage);

      try {
        var response = await fetch('https://' + shopDomain + '/api/2026-04/graphql.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            query: mutation,
            variables: {
              input: {
                lines: [{ merchandiseId: variantId, quantity: 1 }],
                delivery: {
                  addresses: [{
                    selected: true,
                    oneTimeUse: true,
                    address: {
                      deliveryAddress: {
                        countryCode: 'AU',
                        zip: postcode,
                        provinceCode: state
                      }
                    }
                  }]
                }
              }
            }
          })
        });

        if (!response.ok) throw new Error('Shipping estimate request failed.');
        var payload = await response.json();
        if (payload.errors && payload.errors.length) throw new Error('Shopify could not calculate a shipping estimate.');

        var result = payload.data && payload.data.cartCreate;
        if (!result || (result.userErrors && result.userErrors.length)) {
          throw new Error('Shopify could not calculate a shipping estimate.');
        }

        var hasRates = renderRates(rates, result.cart && result.cart.deliveryGroups && result.cart.deliveryGroups.nodes, messages.rateFallback);
        setStatus(status, hasRates
          ? messages.successTemplate.replace('__POSTCODE__', postcode).replace('__STATE__', state)
          : messages.noRatesMessage);
      } catch {
        setStatus(status, messages.errorMessage);
      } finally {
        submitButton.disabled = false;
      }
    });
  }

  function scanEstimators(scope) {
    (scope || document).querySelectorAll('[data-thw-product-shipping-estimator]').forEach(initialiseEstimator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scanEstimators(document); }, { once: true });
  } else {
    scanEstimators(document);
  }

  document.addEventListener('shopify:section:load', function (event) { scanEstimators(event.target); });
})();
